import { FC, useRef, useEffect, createRef, useMemo, useState, RefObject } from "react";
import ComponentLoader, { EComponentList } from "../shared/ComponentLoader/ComponentLoader";
import { GetProductCentricNavList, PCNavListItemType, PCNavTitles } from "../../utils/projectUtils";
import "./CertWorkflowApp.scss";
import PublishProvider from "./PublishContext";
import CertWorkflowAppWrapper from "./CertWorkflowAppWrapper";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import { CWRouteParams } from "../../constants/router";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import ProjectDetailsHeader from "../shared/ProjectDetailsHeader/ProjectDetailsHeader";
import { flatMap } from "lodash";
import { Bullseye, Grid, GridItem, Sidebar, SidebarContent, SidebarPanel, TabContent, TabContentBody } from "@patternfly/react-core";
import ProjectDetailsSidenav from "../shared/ProjectDetailsSidenav/ProjectDetailsSidenav";
import { RHCErrorPage } from '@rhc-shared-components/error-page';
import { useProjectDetails } from "../../queries/getProjectDetails";

const UpdateGraph = ({match}) => (<ComponentLoader componentName={EComponentList.UpdateGraph} match={match}/>);
const ImageList = ({match}) => (<ComponentLoader componentName={EComponentList.ImageList} match={match}/>);
const CertificationTab = ({match}) => (<ComponentLoader componentName={EComponentList.Certifications} match={match}/>);
const RepositoryInfo = ({match}) => (<ComponentLoader componentName={EComponentList.RepositoryInfo} match={match}/>);
const ComponentDetails = ({match}) => (<ComponentLoader componentName={EComponentList.ComponentDetails} match={match}/>);
const ContactInfo = ({match}) => (<ComponentLoader componentName={EComponentList.ContactsInfo} match={match}/>);
const OptionalQualifications = ({match}) => (<ComponentLoader componentName={EComponentList.OptionalQualifications} match={match}/>);
const SecurityTab = ({ match }) => (<ComponentLoader componentName={EComponentList.Security} match={match} />);
const AssociatedProductTab = ({match}) => (<ComponentLoader componentName={EComponentList.AssociatedProduct} match={match} />);

const PCComponentListObj = {
  [PCNavTitles.Images]: ImageList,
  [PCNavTitles.Certification]: CertificationTab,
  [PCNavTitles.UpdateGraph]: UpdateGraph,
  [PCNavTitles.Security]: SecurityTab,
  [PCNavTitles.UpdateGraph]: UpdateGraph,
  [PCNavTitles.RepositoryInformation]: RepositoryInfo,
  [PCNavTitles.ComponentDetails]: ComponentDetails,
  [PCNavTitles.ContactInfo]: ContactInfo,
  [PCNavTitles.OptionalQualifications]: OptionalQualifications,
  [PCNavTitles.AssociatedProduct]: AssociatedProductTab
}
const ComingSoon = () => (
  <Bullseye style={{
    paddingTop: `4em`
  }}>
    COMING SOON!
  </Bullseye>
);
const CertWorkflowAppMain: FC<{
  navList: PCNavListItemType[]
}> = ({navList}) => {
  const location = useLocation();
  const contentRefs = useRef<{[key: number]: RefObject<any>}>({});
  const [activeTabKey, setActiveTabKey] = useState<number>(0);

  useEffect(() => {
    navList.forEach((_, index) => {
      if (!contentRefs.current[index]) {
        contentRefs.current[index] = createRef();
      }
    });
  }, [navList]);

  useEffect(() => {
    const currentIndex = navList.findIndex(item => location.pathname.includes(item.path));
    if (currentIndex !== -1) {
      setActiveTabKey(currentIndex);
    }
  }, [location.pathname, navList]);

  return (<span className='cwf-main'>
    <ProjectDetailsHeader />
    <Grid>
      <GridItem span={10} offset={1}>
        <Sidebar hasGutter={true}>
          <SidebarPanel>
            <ProjectDetailsSidenav
              navList={navList}
              contentRefs={contentRefs}
              activeTabKey={activeTabKey}
              setActiveTabKey={setActiveTabKey}
            />
          </SidebarPanel>
          <SidebarContent>
            <div className="cwf-main__sidebar-content">
              {navList.map((item, index) => {
                const Component = PCComponentListObj?.[item.text] || ComingSoon;
                return (
                  <TabContent
                    key={item.text}
                    eventKey={index}
                    id={`tab-content-${index}`}
                    ref={contentRefs.current[index]}
                    aria-label={item.text}
                    hidden={activeTabKey !== index}
                  >
                    <TabContentBody>
                      <Component match={{params: {}, isExact: true, path: item.route, url: item.path}} />
                    </TabContentBody>
                  </TabContent>
                );
              })}
            </div>
          </SidebarContent>
        </Sidebar>
      </GridItem>
    </Grid>
  </span>)
}

const CertWorkflowRouter = () => {
  // handles initial routing and 404
  const params = useParams<CWRouteParams>();
  const { data: projectDetails } = useProjectDetails(params.id);
  const navList = useMemo(() => GetProductCentricNavList(projectDetails, params), [projectDetails, params]);
  const routeList = flatMap(navList, 'route');
  const match = useRouteMatch();
  return (<Switch>
    {navList?.[0]?.path &&
      <Redirect
        exact
        from={`${match.path}`}
        to={navList?.[0]?.path}
      />
    }
    <Route path={routeList} component={() =>  <CertWorkflowAppMain navList={navList} />}/>
    <Route
      render={() => (
        <RHCErrorPage errorStatus={404} />
      )}
    />
  </Switch>)
}
export const CertWorkflowApp = () => (
  <PublishProvider>
    <CertWorkflowAppWrapper>
      <CertWorkflowRouter />
    </CertWorkflowAppWrapper>
  </PublishProvider>
);
